import {
  organisationKeys,
  RequestTypes,
} from '@core/react-query/features/organisations/organisation'
import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { IOrganisation, Organisation } from '@core/entities/organisation'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useGetOrganisation = (
  payload: RequestTypes['getOrganisation'],
  options: UseQueryOptions<IOrganisation, RequestErrorType, Organisation> = {},
) => {
  return useQuery<IOrganisation, RequestErrorType, Organisation>({
    select: Organisation.new,
    ...organisationKeys.byId(payload),
    enabled: !!payload.organisationId,
    ...options,
  })
}
